import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';

@Component({
  selector: 'app-switch',
  templateUrl: './switch.component.html',
  styleUrls: ['./switch.component.css']
})
export class SwitchComponent {
  @Output() onChange = new EventEmitter();
  constructor() {}
  onChangeEstatus(event: EventTarget) {
    const input = event as HTMLInputElement;
    this.onChange.emit(input.checked);
  }
}
